export default {
  install: function (Vue) {
    if (window.google) {
      let callback = null
      window.google.accounts.id.initialize({
        client_id: process.env.GOOGLE_OAUTH_CLIENT_ID,
        itp_support: true,
        callback: result => {
          callback && callback(result)
          callback = null
        }
      })

      Vue.prototype.$createGoogleLoginBtn = async function ({ onSelectedAccount }) {
        const parent = document.getElementById('google_btn')
        if (parent) {
          await this.$nextTick()
          let loginWrapper = document.getElementById('loginWrapper')
          let wrapperWidth = '100%'
          if (loginWrapper) { wrapperWidth = document.getElementById('loginWrapper').clientWidth }
          window.google.accounts.id.renderButton(parent, {
            theme: 'dark',
            width: wrapperWidth || '100%'
          })
          window.google.accounts.id.prompt()
        }

        callback = onSelectedAccount
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/createGoogleButton.js